var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotakbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.6116C0 11.97 10.0306 3.3418 22.4054 3.3418C34.7802 3.3418 44.8099 11.97 44.8099 22.6116C44.8099 33.2532 34.7793 41.8814 22.4054 41.8814C10.0314 41.8814 0 33.2545 0 22.6116Z",
    fill: "#003874"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6849 9.52948L24.8903 7.80957L24.916 35.949L19.6665 37.7078L19.6849 9.52948Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.255 24.5514C38.7666 28.5766 36.5087 32.6433 31.5784 32.651C28.7001 32.6561 26.4516 30.6854 24.8945 28.2741V25.4812C26.843 26.4486 28.6642 27.487 30.8738 27.5186C33.5957 27.5588 36.057 26.5123 37.0749 24.5509H39.2554L39.255 24.5514ZM22.7738 27.0789C20.512 29.8051 18.3264 32.5899 14.2311 32.5899C8.44661 32.5899 5.70288 26.9973 5.70288 22.3217C5.70288 17.829 7.8471 12.5107 13.4824 12.5107C15.9266 12.5107 18.2794 14.0055 19.6818 15.5865L19.6775 19.4002C18.5058 18.6114 15.8813 17.8375 14.1678 17.8098C10.5943 17.7499 7.44373 19.2989 7.49842 22.8263C7.5356 25.2547 9.94176 26.9054 12.3355 26.9054C16.0018 26.9054 18.223 23.5562 20.0792 21.0141C20.8234 20.0438 21.5591 19.0669 22.2862 18.0837C24.348 15.2028 26.7336 12.5727 30.8289 12.5727C35.6532 12.5727 38.3615 16.4612 39.1272 20.4642H36.9479C36.072 19.166 34.3871 18.3717 32.7274 18.3717C28.9372 18.3717 26.6725 21.8585 24.777 24.4257L22.7686 27.0785",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotakbank);
export default __webpack_public_path__ + "static/media/kotakbank.81988fcba7b692df4e6af1ed688fb039.svg";
export { ForwardRef as ReactComponent };